import accountableHelper from "./accountables";

function buildProfessionalAttributes(professional) {
  return { cpf: professional.cpf, mei: professional.mei };
}

function buildDocument(professional) {
  return { document_type: "CPF", document_number: professional.cpf };
}

function createRequestBody(payload) {
  return {
    data: {
      attributes: buildProfessionalAttributes(payload.professional),
      relationships: accountableHelper.buildAccountableRelationships(payload)
    }
  };
}

export default { createRequestBody, buildDocument };



// WEBPACK FOOTER //
// ./src/API/helpers/professionals.js